import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "selected"]

  connect() {
    this.updateSelected()
  }

  updateSelected() {
    this.selectedTargets.forEach(target => {
      target.textContent =
        [...this.selectTarget.options]
          .filter(option => option.selected)
          .map(option => option.textContent)
          .join(", ") || "none"
    })
  }
}
